import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

const SESSION_TIMEOUT_MINUTES = 30;

class SessionGuard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expired: false
    };
  }

  componentDidMount() {
    this.checkSessionTimeout();

    // Revisa cada 10 segundos si expiró
    this.interval = setInterval(this.checkSessionTimeout, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  checkSessionTimeout = () => {
    const maxExpiration = localStorage.getItem('session_max_expiration');
    const now = new Date().getTime();

    if (!maxExpiration) {
      const expiryTime = now + SESSION_TIMEOUT_MINUTES * 60000;
      localStorage.setItem('session_max_expiration', expiryTime);
      console.log('Hora de expiración absoluta registrada:', new Date(expiryTime));
      return;
    }

    if (now > parseInt(maxExpiration)) {
      console.log('Sesión expirada por timeout absoluto!');
      this.clearAllData();
      this.setState({ expired: true });
    }
  }

  clearAllData = () => {
    // Borrar localStorage
    localStorage.clear();

    // Borrar cookies
    document.cookie.split(";").forEach(cookie => {
      document.cookie = cookie
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    console.log('LocalStorage y cookies eliminados.');
  }

  render() {
    if (this.state.expired) {
        window.location.href = '/mi-sendero';
    }

    return this.props.children;
  }
}

export default SessionGuard;
